import { useTranslation } from 'next-i18next/pages'

import type { AppUser } from '../../../../types/app'

import {
  StyledContainer,
  StyledLogoutLink,
  StyledUserData,
  StyledUserName,
} from './HeaderUser.Styled'

type HeaderUserProps = {
  className?: string
  user: Omit<AppUser, 'uid'>
}

export const HeaderUser = ({ className, user }: HeaderUserProps) => {
  const { t } = useTranslation()

  return (
    <StyledContainer className={className}>
      <StyledUserData>
        <StyledUserName
          $textAlign="right"
          $variant="Poppins/T3"
          title={user?.email ?? ''}
        >
          {user.displayName || user?.email}
        </StyledUserName>

        {user.onLogout && (
          <StyledLogoutLink
            as="a"
            $variant="Poppins/T4"
            onClick={user.onLogout}
          >
            {t('login_logout')}
          </StyledLogoutLink>
        )}
      </StyledUserData>
    </StyledContainer>
  )
}
